//VIDEO_SIDEBAR
export const TOGGLE_BAR = "bar";
export const TOGGLE_NOTES = "notes";
// export const TOGGLE_HYBRID_CONTENT = "hybrid";
export const TOGGLE_NEXT_CONTENT = "nextcontent";
export const TOGGLE_COMMENTS_CONTENT = "comments";
export const TOGGLE_ASSIGNMENT_CONTENT = "assignment";
